import {
  AfterViewInit, Directive, ElementRef, EventEmitter, Input,
  OnChanges, OnDestroy, Output, SimpleChanges
} from '@angular/core';

@Directive({
  selector: '[appInfiniteScroll]',
  standalone: true
})
export class InfiniteScrollDirective implements AfterViewInit, OnDestroy, OnChanges {
  @Output() reachedEnd = new EventEmitter<void>();
  @Input() disabled = false;

  private io?: IntersectionObserver;

  constructor(private el: ElementRef<HTMLElement>) {}

  ngAfterViewInit() {
    this.io = new IntersectionObserver(entries => {
      if (this.disabled) return;
      if (entries.some(e => e.isIntersecting)) {
        this.reachedEnd.emit();
        // Pausa para evitar ráfagas; se re-activa cuando disabled cambie a false
        this.io?.unobserve(this.el.nativeElement);
      }
    }, { 
      root: null, 
      rootMargin: '600px 0px', 
      threshold: 0 
    });

    this.updateObservation();
  }

  ngOnChanges(_: SimpleChanges) {
    this.updateObservation();
  }

  private updateObservation() {
    if (!this.io) return;
    const host = this.el.nativeElement;
    this.io.unobserve(host);
    if (!this.disabled) this.io.observe(host);
  }

  ngOnDestroy() {
    this.io?.disconnect(); 
  }
}